export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAILURE = "REGISTER_USER_FAILURE";
export const INITIATE_REGISTER_USER = "INITIATE_REGISTER_USER";
